export default "__VITE_ASSET__n0LlgI30__"